// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__26z5p","boxTitle":"Qualiphy_boxTitle__1c0-3","box":"Qualiphy_box__-u2n_","toggleWrap":"Qualiphy_toggleWrap__21cLD"};